import { render, staticRenderFns } from "./pyb-key-word.vue?vue&type=template&id=d8ddbb34&scoped=true&"
import script from "./pyb-key-word.vue?vue&type=script&lang=js&"
export * from "./pyb-key-word.vue?vue&type=script&lang=js&"
import style0 from "./pyb-key-word.vue?vue&type=style&index=0&id=d8ddbb34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ddbb34",
  null
  
)

export default component.exports